import { render } from "./ContactFloat.vue?vue&type=template&id=2295918c&scoped=true"
import script from "./ContactFloat.vue?vue&type=script&lang=js"
export * from "./ContactFloat.vue?vue&type=script&lang=js"

import "./ContactFloat.vue?vue&type=style&index=0&id=2295918c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2295918c"]])

export default __exports__